import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { CompanyDocList } from "../../components/admin/documents/CompanyDocList";
import { UploadDocForm } from "../../components/admin/documents/UploadDocForm";

const CATEGORIES = ["Hierarchy Chart", "Travel Policy", "Leave Policy", "HR Policy", "Code of Conduct", "Safety Guidelines", "Other"];

export default function CompanyDocs() {
  const [docs, setDocs] = useState([]);
  const [filter, setFilter] = useState("");

  const load = useCallback(() => api.get("/company-documents", { params: { category: filter } }).then((r) => setDocs(r.data)), [filter]);
  useEffect(() => { load(); }, [load]);

  const del = async (id) => {
    await api.delete(`/company-documents/${id}`);
    toast.success("Document removed");
    load();
  };

  return (
    <div className="space-y-6 max-w-4xl" data-testid="company-docs-page">
      <div>
        <h1 className="font-heading text-3xl font-extrabold tracking-tight">Company documents</h1>
        <p className="text-stone-500 text-sm mt-1">Hierarchy charts, policies and guidelines — visible to all employees.</p>
      </div>

      <UploadDocForm categories={CATEGORIES} onUploaded={load} />

      <div className="flex gap-2 flex-wrap">
        <button onClick={() => setFilter("")} data-testid="company-doc-filter-all"
          className={`px-4 py-2 rounded-full text-xs font-bold transition-colors duration-200 ${filter === "" ? "bg-secondary text-white" : "bg-white border border-stone-200 text-stone-600"}`}>All</button>
        {CATEGORIES.map((c) => (
          <button key={c} onClick={() => setFilter(c)} data-testid={`company-doc-filter-${c.toLowerCase().replace(/ /g, "-")}`}
            className={`px-4 py-2 rounded-full text-xs font-bold transition-colors duration-200 ${filter === c ? "bg-secondary text-white" : "bg-white border border-stone-200 text-stone-600"}`}>{c}</button>
        ))}
      </div>

      <CompanyDocList docs={docs} onDelete={del} />
    </div>
  );
}
